<template>
    <v-menu eager location="left">
        <template v-slot:activator="{ props }">
            <v-btn-add-icon
                variant="plain"
                color="secondary"
                density="comfortable"
                class="pl-1"
                v-bind="props"
            />
        </template>
        <v-card class="pa-0" elevation="2" rounded="md">
            <v-card-text class="pa-2">
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-btn-toggle class="d-flex fill-width" style="background-color: white">
                            <v-btn
                                rounded
                                outlined
                                class="flex-grow-1"
                                elevation="0"
                                @click="OnMailOptionSelected('$TITLE')"
                                size="small"
                            >
                                Titre
                            </v-btn>
                            <v-btn
                                rounded
                                outlined
                                class="flex-grow-1"
                                elevation="0"
                                @click="OnMailOptionSelected('$NUMBER')"
                                size="small"
                            >
                                Numéro de facture
                            </v-btn>
                            <v-btn
                                rounded
                                outlined
                                class="flex-grow-1"
                                elevation="0"
                                @click="OnMailOptionSelected('$PRICE')"
                                size="small"
                            >
                                Prix
                            </v-btn>
                            <v-btn
                                rounded
                                outlined
                                class="flex-grow-1"
                                elevation="0"
                                @click="OnMailOptionSelected('$IBAN')"
                                size="small"
                            >
                                IBAN
                            </v-btn>
                        </v-btn-toggle>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-btn-toggle class="d-flex fill-width" style="background-color: white">
                            <v-btn
                                rounded
                                outlined
                                class="flex-grow-1"
                                elevation="0"
                                @click="OnMailOptionSelected('$USER_NAME')"
                                size="small"
                            >
                                Utilisateur
                            </v-btn>
                            <v-btn
                                rounded
                                outlined
                                class="flex-grow-1"
                                elevation="0"
                                @click="OnMailOptionSelected('$COMPANY_NAME')"
                                size="small"
                            >
                                Société emettrice
                            </v-btn>
                            <v-btn
                                rounded
                                outlined
                                class="flex-grow-1"
                                elevation="0"
                                @click="OnMailOptionSelected('$CLIENT_COMPANY_NAME')"
                                size="small"
                            >
                                Société destinataire
                            </v-btn>
                            <v-btn
                                rounded
                                outlined
                                class="flex-grow-1"
                                elevation="0"
                                @click="OnMailOptionSelected('$RECEIVER_NAME')"
                                size="small"
                            >
                                Contact client
                            </v-btn>
                        </v-btn-toggle>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-btn-toggle class="d-flex fill-width" style="background-color: white">
                            <v-btn
                                rounded
                                outlined
                                class="flex-grow-1"
                                elevation="0"
                                @click="OnMailOptionSelected('$INVOICE_DATE')"
                                size="small"
                            >
                                Date
                            </v-btn>
                            <v-btn
                                rounded
                                outlined
                                class="flex-grow-1"
                                elevation="0"
                                @click="OnMailOptionSelected('$INVOICE_DUE_DATE')"
                                size="small"
                            >
                                Date d'échéance
                            </v-btn>
                            <v-btn
                                v-if="isInvoiceNextDueDate"
                                rounded
                                outlined
                                class="flex-grow-1"
                                elevation="0"
                                @click="OnMailOptionSelected('$INVOICE_NEXT_DUE_DATE')"
                                size="small"
                            >
                                Délai + 30 jours
                            </v-btn>
                        </v-btn-toggle>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-menu>
</template>

<script lang="ts">
import { Component, Vue, toNative, Prop, Model, Emit } from "vue-facing-decorator";

@Component
export class MailOptions extends Vue {
    @Prop({ default: "" }) reference: string;
    @Prop({ default: "" }) modelPropertyName: string;
    @Prop({ default: 0 }) startPos: number;
    @Prop({ default: 0 }) endPos: number;
    @Prop({ default: false }) isInvoiceNextDueDate: boolean;

    @Model({ default: null, name: "text" }) text_: string;

    @Emit
    OnMailOptionSelected(text: string) {
        return { text: text, newCursorPos: this.startPos + text.length, modelPropertyName: this.modelPropertyName };
    }
}

export default toNative(MailOptions);
</script>
